import { createRouter, createWebHistory } from 'vue-router'
import { chRoutes } from './chRoutes.js'
import { enRoutes } from './enRoutes.js'
import ch from '@/views/ch.vue'
import en from '@/views/en.vue'

const routes = [
    {
        path: '/',
        name: 'ch',
        component: ch,
        children: chRoutes,
        meta: {
            title: '海洋廢棄物循環利用及標章申請資訊專區',
        },
    },
    {
        path: '/en',
        name: 'en',
        component: en,
        children: enRoutes,
        meta: {
            title: 'Recycled Marine Debris Product Label Information Zone',
        },
    },
    // {
    //     path: '/:catchAll(.*)',
    //     redirect: '/',
    // },
]

const router = createRouter({
    history: createWebHistory(
        process.env.NODE_ENV === 'production' ? '/MarineDebris/' : '/'
    ),
    routes,
})

router.afterEach((to, from) => {
    if (to.name !== from.name) {
        window.scroll({
            top: 0,
            left: 0,
        })
    }
    document.title = to.meta.title
})
/*
function getRoutesList(routes, pre) {
    return routes.reduce((array, route) => {
        const path = `${pre}${route.path}`
        if (route.path !== '*') {
            array.push(path)
        }

        if (route.children) {
            array.push(...getRoutesList(route.children, `${path}/`))
        }
        return array
    }, [])
}

function getRoutesXML() {
    const list = getRoutesList(
        router.options.routes,
        'https://marine-debris-test-2022.octave.vip'
    )
        .map((route) => `<url><loc>${route}</loc></url>`)
        .join('\r\n')
    return `<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.sitemaps.org/schemas/sitemap/0.9 http://www.sitemaps.org/schemas/sitemap/0.9/sitemap.xsd"> ${list} </urlset>`
}

console.log(getRoutesXML())
*/
export default router
